<tam-dialog class="save-content-body" tid="intralink_account_dialog" [opened]="isOpen" [dialogWidth]="500"
    (keydown.esc)="onCancelClick()">
    <ng-template #title>
        <div class="title-box">
            <span>{{pageTitle}}</span>
        </div>
        <div class="close-button-box">
            <smart-icon class="dark small" name="close" (click)="onCancelClick()"></smart-icon>
        </div>
    </ng-template>

    <form [formGroup]="screenForm">
        <ng-template #body>
            <div class="flex-container">
                <div class="tam-form-field" [ngClass]="{'has-error': username.invalid}">
                    <div class="tam-form-label">
                        <span>Client Id&nbsp;<span class="required-field">*</span></span>
                    </div>
                    <input type="text" class="tam-textbox" formControlName="username" autocomplete="off">
                    <div class="tam-form-help" *ngIf="username.invalid && username.errors['required']">
                        {{'general.required_error_message' | stringLiterals}}</div>
                    <div class="tam-form-help"
                        *ngIf="password.invalid && username.invalid && username.errors['errorValue']">Invalid Client Id
                        or Client Secret</div>
                    <div class="tam-form-help" *ngIf="username.errors && username.errors['duplicated']">Intralinks
                        {{'general.client_id_already_exist' | stringLiterals}}</div>
                </div>
                <div class="tam-form-field" [ngClass]="{'has-error': password.invalid}">
                    <div class="tam-form-label">
                        <span>Client Secret&nbsp;<span class="required-field">*</span></span>
                    </div>
                    <input type="password" class="tam-textbox" formControlName="password" autocomplete="off">
                    <div class="tam-form-help" *ngIf="password.invalid && password.errors['required']">
                        {{'general.required_error_message' | stringLiterals}}</div>
                    <div class="tam-form-help"
                        *ngIf="password.invalid && password.errors && password.errors['errorValue']">Invalid Client Id
                        or Client Secret</div>
                </div>
                <div class="tam-form-field">
                    <div class="tam-form-label">
                        <span>Account Nickname&nbsp;<span class="required-field">*</span></span>
                    </div>
                    <input type="text" class="tam-textbox" formControlName="alias" pattern="^[^ ].+[^ ]$">
                    <div class="tam-form-help" *ngIf="alias.invalid && alias.errors['required']">
                        {{'general.required_error_message' | stringLiterals}}</div>
                    <!-- the below error message maybe used for duplicate -->
                    <div class="tam-form-help" *ngIf="alias.errors && alias.errors['duplicated']">Intralinks Account
                        {{'general.nickname_already_exist' | stringLiterals}}</div>
                </div>
                <div class="list-box">
                    <tam-dual-list #dualList [config]="dualListConfig" [itemRender]="accessListItem">
                        <ng-template #accessListItem let-item>
                            <div class="access-item">
                                <span
                                    [style.font-weight]="item.data.type === 'Team' ? 'bold' : 'normal'">{{item.data.name}}</span>
                            </div>
                        </ng-template>
                    </tam-dual-list>
                </div>
            </div>
        </ng-template>
    </form>

    <ng-template #footer>
        <label tam-checkbox [(ngModel)]="endOtherSessions" class="footer-checkbox"
            title="Automatically end other sessions when concurrent session limitation reached in Intralinks">End Other
            Sessions</label>
        <button class="footer-button footer-research-button" tam-button [tamType]="'tertiary'" [tamSize]="'normal'"
            (click)="onCancelClick()">Cancel</button>
        <button class="footer-button footer-research-button" tam-button [tamType]="'primary'" [tamSize]="'normal'"
            [tamLoading]="isSaving" [disabled]="saveBtnStatus&&originEndOtherSessions===endOtherSessions"
            (click)="onSaveClick()">Save</button>
    </ng-template>

</tam-dialog>